import { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PATHS } from 'src/common/constants';
import { getItems } from 'src/services/client';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { SidebarContextRow } from '../Components/SidebarContextTree';

interface RouteParams {
  id: string;
}

const useItemContextRows = (): SidebarContextRow[] | null => {
  const match = useRouteMatch<RouteParams>({ path: PATHS.ITEMS_VIEW });
  const itemId: string = match?.params?.id ?? '';

  const user: any = useSelector(selectAuthenticatedUser);

  const [item, setItem] = useState<any>(null);

  useEffect(() => {
    if (!itemId || !user?.id) {
      return;
    }

    let active: boolean = true;

    const loadItem = async () => {
      try {
        const response: any = await getItems(user.id, user.roles[0].role.name);

        if (!response.ok && response.status !== 200) {
          return;
        }

        const items: any[] = await response.json();
        const found: any = items.find((entry: any) => entry.id === itemId);

        if (active) {
          setItem(found ?? null);
        }
      } catch (err: any) {
        console.error('useItemContextRows getItems failed:', err);
      }
    };

    loadItem();

    return () => {
      active = false;
    };
  }, [itemId, user?.id]);

  if (!match || !itemId) {
    return null;
  }

  return [
    {
      label: item?.name ?? '',
      path: PATHS.ITEMS_VIEW.replace(':id', itemId),
      icon: 'box',
      loading: !item,
    },
  ];
};

export default useItemContextRows;
